<template>
  <section class="priAdmin">
    <viewTitle
      class="viewTitle"
      title="权限管理 / 指定管理员"
      :showReturn="false"
    ></viewTitle>
    <div class="listAdmin">
      <p class="">
        <span class="listAdminT">系统管理员:</span>
        <span
          class="adminItem"
          v-for="(item, index) in listSuperAdmin"
          :key="index"
        >
          <User :item="item" :type="'user'" />
        </span>
        <el-button type="text" @click="selectSuperAdmin" size="small">
          修 改
        </el-button>
      </p>
    </div>
    <div class="listAdmin">
      <p class="listAdminTitle">业务管理</p>
      <p v-for="(item, index) in listAdmin" :key="index" class="">
        <span class="listAdminT">{{ item.name }}:</span>
        <span
          class="adminItem"
          v-for="(user, indexuser) in item.users"
          :key="indexuser"
        >
          <User :item="user" :type="'user'" />
        </span>
        <el-button type="text" @click="ywSelectSuperAdmin(item)" size="small">
          修 改
        </el-button>
      </p>
    </div>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />
    <Dept
      v-if="ywDeptListObj.reCreat"
      :model="ywDeptListObj.model"
      :title="ywDeptListObj.title"
      :visible="ywDeptListObj.visible"
      :selected="ywDeptListObj.pluginResult.select"
      @confirm="ywDeptListObjConfirm"
      @updateVisible="ywDeptListObjUpdateVisible"
    />
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
export default {
  data() {
    return {
      listSuperAdmin: [],
      listAdmin: [],
      deptListObj: {
        title: "指定系统管理员",
        model: "user",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      ywDeptListObj: {
        reCreat: false,
        title: "",
        model: "user",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      editAdmin: {}
    };
  },
  components: {
    viewTitle,
    Dept,
    User
  },
  methods: {
    getListSuperAdmin() {
      this.$common
        .http({
          url: "/api/role_union/list_super_union"
        })
        .then(res => {
          this.listSuperAdmin = res.data.data.users;
          this.deptListObj.pluginResult.select.user = res.data.data.users;
        });
    },
    setSuperAdminUser(users) {
      this.$common
        .http({
          url: "/api/role_union/save_super_union",
          data: {
            users
          }
        })
        .then(() => {
          this.listSuperAdmin = this.deptListObj.pluginResult.select.user;
        });
    },
    getListAdmin() {
      this.$common
        .http({
          url: "/api/role_union/list_super"
        })
        .then(res => {
          this.listAdmin = res.data.data;
        });
    },
    setAdminUser(users) {
      this.$common
        .http({
          url: "/api/role_union/save_super",
          data: {
            users: users,
            com_id: this.editAdmin.id
          }
        })
        .then(() => {
          this.getListAdmin();
        });
    },
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      let users = [];
      this.deptListObj.pluginResult.select.user.forEach(item => {
        users.push(item.id);
      });
      this.setSuperAdminUser(users);
    },
    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },
    selectSuperAdmin() {
      this.deptListObj.visible = true;
    },
    ywDeptListObjConfirm(obj) {
      for (let key in obj) {
        this.ywDeptListObj.pluginResult.select[key] = obj[key];
      }
      let users = [];
      this.ywDeptListObj.pluginResult.select.user.forEach(item => {
        users.push(item.id);
      });
      this.setAdminUser(users);
    },
    ywDeptListObjUpdateVisible(val) {
      this.ywDeptListObj.visible = val;
      if (!val) {
        this.$nextTick(() => {
          this.ywDeptListObj.reCreat = false;
        });
      }
    },
    ywSelectSuperAdmin(item) {
      this.editAdmin = item;
      this.ywDeptListObj.pluginResult.select.user = item.users;
      this.ywDeptListObj.title = `指定 [ ${item.name} ] 管理员`;
      this.ywDeptListObj.reCreat = true;
      this.$nextTick(() => {
        this.ywDeptListObj.visible = true;
      });
    }
  },
  created() {
    this.getListSuperAdmin();
    this.getListAdmin();
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.priAdmin {
  .viewTitle {
    padding: 16px 16px 0 16px;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
    box-sizing: border-box;
  }
  .listAdmin {
    padding: 16px 16px 0 16px;
    .listAdminTitle {
      padding-bottom: 5px;
    }
    .listAdminT {
      margin-right: 8px;
    }
    > p {
      margin: 0;
    }
    .adminItem {
      margin-right: 8px;
    }
  }
}
</style>
<style lang="less">
.priAdmin {
  .listAdmin {
    > p {
      i {
        display: none !important;
      }
    }
  }
}
</style>
